import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUsersActions } from '../../actions/UserActions';
import { useStore, TOKEN } from '../../store';
import * as google from '../../utils/google';
import { useQueryClient } from 'react-query';
import { IS_SINGLE_TENENT_MODE } from '../../constants';

function noop() {}

export default function GoogleSignInButton({
  onError = noop,
  width,
  text,
  inviteToken,
  referralToken,
}) {
  const navigate = useNavigate();

  const { signInWithGoogleAsync } = useUsersActions();
  const [, setToken] = useStore(TOKEN);
  const client = useQueryClient();

  const cb = useMemo(
    () => async (response) => {
      const googleToken = response.credential;
      try {
        const { token, otp, secure_login } = await signInWithGoogleAsync({
          token: googleToken,
          inviteToken,
          referralToken,
        });
        setToken(token);
        client.clear();

        if (otp) {
          navigate('/2fa-verify');
          return;
        }

        if (secure_login) {
          navigate('/secure-login/verify');
          return;
        }

        navigate('/');
      } catch (e) {
        console.log('error', e);
        onError(e);
      }
    },
    [
      signInWithGoogleAsync,
      setToken,
      navigate,
      onError,
      inviteToken,
      referralToken,
      client,
    ]
  );

  useEffect(() => {
    google.init(cb);
  }, [cb]);

  useEffect(() => {
    google.renderButton({ width, text });
  }, []);

  if (IS_SINGLE_TENENT_MODE) {
    return null;
  }

  return <div id="googleButtonDiv" />;
}
